import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { STORE, waLink, telLink } from "@/lib/store";

export default function Footer() {
    return (
        <footer className="bg-charcoal text-white relative overflow-hidden" data-testid="site-footer">
            <div className="absolute inset-0 bg-blueprint opacity-60 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-6">
                        <Link to="/" className="flex items-center gap-3">
                            <img
                                src="/brand/ths-logo.jpg"
                                alt="The Hardware Store logo"
                                className="w-11 h-11 rounded-md object-cover border border-white/10"
                            />
                            <span className="font-display font-extrabold text-xl tracking-tight leading-none">
                                The Hardware <span className="text-safety">Store</span>
                            </span>
                        </Link>
                        <p className="mt-4 text-white/70 max-w-md leading-relaxed">
                            {STORE.tagline} Serving contractors, homeowners and DIY enthusiasts across{" "}
                            {STORE.serviceArea} since {STORE.since}.
                        </p>

                        <div className="mt-6 flex items-center gap-3">
                            <a href={telLink()} data-testid="footer-call-btn"
                               className="inline-flex items-center gap-2 px-4 h-11 rounded-full bg-white/10 hover:bg-white/20 border border-white/15 transition-colors text-sm font-medium">
                                <Phone className="w-4 h-4" /> Call
                            </a>
                            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-btn"
                               className="inline-flex items-center gap-2 px-4 h-11 rounded-full bg-safety hover:bg-safety-hover text-white text-sm font-medium btn-shine">
                                <MessageCircle className="w-4 h-4" /> WhatsApp
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <p className="uppercase tracking-[0.25em] text-xs text-white/50 font-semibold mb-4">Hours</p>
                        <ul className="space-y-2 text-white/80 text-sm">
                            {STORE.hours.map((h) => (
                                <li key={h.label}>
                                    <div className="text-white font-semibold">{h.label}</div>
                                    <div className="text-white/60">{h.value}</div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="uppercase tracking-[0.25em] text-xs text-white/50 font-semibold mb-4">Contact</p>
                        <ul className="space-y-2 text-sm">
                            <li className="flex items-center gap-2 text-white/80">
                                <Phone className="w-4 h-4 text-safety" /> {STORE.phoneDisplay}
                            </li>
                            <li className="flex items-center gap-2 text-white/80 break-all">
                                <Mail className="w-4 h-4 text-safety" /> {STORE.email}
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
                    <p>© {new Date().getFullYear()} The Hardware Store. All rights reserved.</p>
                    <p>Built for the community, one project at a time.</p>
                </div>
            </div>
        </footer>
    );
}
